// import { useState, useEffect } from "react";
// import axios from "axios";

// const Income = () => {
//   const [depositData, setDepositData] = useState<any>([]);
//   const [status, setStatus] = useState(false);
//    const [filteredData, setFilteredData] = useState<any[]>([]); // State for filtered deposit data based on search
//   const [searchTerm, setSearchTerm] = useState(''); // State for the search term
//   const [editIndex, setEditIndex] = useState<number | null>(null); // Track which row is being edited
//   const [editValue, setEditValue] = useState(''); 

//   useEffect(() => {
//     const headers = {
//       "Content-Type": "application/json",
//       "Access-Control-Allow-Origin": "*",
//       "Access-Control-Allow-Methods": "*",
//     };

//     axios
//       .get(`${API_BASE}/api/income/getIncomeAll`, { headers })
//       .then((response) => {
//         console.log(response.data.Referal);
//         const deposit: any = Object.values(response.data.Income);
//         setDepositData(deposit);
//         setFilteredData(deposit); // Initially, filtered data is the same as all data

//       })
//       .catch((error) => {
//         console.log("no error " + error);
//       });
//   }, [status]);

//   useEffect(() => {
//     // Filter depositData based on the searchTerm whenever the searchTerm or depositData changes
//     const filtered = depositData.filter((item:any) =>
//       item.email.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredData(filtered);
//   }, [searchTerm, depositData]);
//   const handleUpdateIncome = (index: number) => {
//     // Calculate the original index in the non-reversed array for filteredData
//     const originalIndexFiltered = filteredData.length - 1 - index;
//     const itemFiltered = filteredData[originalIndexFiltered];

//     // Find the same item in depositData to update
//     const originalIndexDeposit = depositData.findIndex((depositItem: { email: any; createdAt: any; }) => depositItem.email === itemFiltered.email && depositItem.createdAt === itemFiltered.createdAt);
//     const itemDeposit = depositData[originalIndexDeposit];

//     axios.post(`${API_BASE}/api/income/updateIncome`, { email: itemFiltered.email, income: editValue, date: itemFiltered.createdAt })
//       .then(response => {
//         // Update filteredData with the new income
//         const newDataFiltered = [...filteredData];
//         newDataFiltered[originalIndexFiltered].income = editValue; // Update the income in the filtered data
//         setFilteredData(newDataFiltered);

//         // Update depositData with the new income if the item exists in it
//         if (itemDeposit && originalIndexDeposit !== -1) {
//           const newDataDeposit = [...depositData];
//           newDataDeposit[originalIndexDeposit].income = editValue; // Update the income in the original data
//           setDepositData(newDataDeposit);
//         }

//         setEditIndex(null); // Reset edit mode
//       })
//       .catch(error => {
//         console.error('Error updating income:', error);
//       });
//   };

//   return (
//     <div>
//       <h1 className="text-2xl font-bold mb-4">Self Income</h1>
//         <input
//         type="text"
//         placeholder="Search by user email..."
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//         className="mb-4 p-2 border rounded"
//       />

//       <div className="h-[690px] overflow-scroll">
//         <table>
//           <thead>
//             <tr>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">S.No.</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">User</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Income Date</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Amount</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Update Income</th>
//             </tr>
//           </thead>
//           <tbody>
//             {[...filteredData].reverse().map((request: any, index: any) => (
//               <tr key={index + 1}>
//                 <td className="py-3 px-8 border-b border-gray-200">{index + 1}</td>
//                 <td className="py-3 px-8 border-b border-gray-200">{request.email} </td>
//                 <td className="py-3 px-8 border-b border-gray-200">{request.createdAt}  </td>
//                 <td className="py-3 px-8 border-b border-gray-200">
//   {Number(request.income).toFixed(2)}
// </td>
// <td className="py-3 px-8 border-b border-gray-200">
//               {editIndex === index ? (
//                 <>
//                   <input
//                     type="text"
//                     value={editValue}
//                     onChange={(e) => setEditValue(e.target.value)}
//                     className="mb-4 p-2 border rounded"
//                   />
//                   <button
//                     onClick={() => handleUpdateIncome(index)}
//                     className="p-2 border rounded bg-blue-500 text-white"
//                   >
//                     Update
//                   </button>
//                 </>
//               ) : (
//                 <button
//                   onClick={() => { setEditIndex(index); setEditValue(request.income.toString()); }}
//                   className="p-2 border rounded bg-green-500 text-white"
//                 >
//                   Edit
//                 </button>
//               )}
//             </td>

//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Income;

import { useState, useEffect, useLayoutEffect, useCallback } from "react";
import axios from "axios";
import { Search, ChevronLeft, ChevronRight, RefreshCw, Edit, Save, X } from "lucide-react";
import { API_BASE } from "../config";

interface IncomeData {
  _id: string;
  email: string;
  Income: number;
  isPlatinum?: boolean;
  createdAt: string;
}

interface PaginationInfo {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

const Income: React.FC = () => {
  const [incomeData, setIncomeData] = useState<IncomeData[]>([]);
  const [pagination, setPagination] = useState<PaginationInfo>({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 20,
    hasNextPage: false,
    hasPrevPage: false
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editValue, setEditValue] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [jumpPage, setJumpPage] = useState("");

  useEffect(() => {
    const t = window.setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => window.clearTimeout(t);
  }, [searchInput]);

  useLayoutEffect(() => {
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  }, [search, pagination.limit]);

  const fetchIncomeData = useCallback(async (page: number, signal?: AbortSignal, limitArg?: number) => {
    setIsLoading(true);
    try {
      const currentLimit = limitArg ?? pagination.limit;
      const params = new URLSearchParams({
        page: String(page),
        limit: String(currentLimit),
        searchTerm: search,
      });
      const response = await axios.get(`${API_BASE}/api/income/admin/getAllIncomePaginated?${params.toString()}`, { signal });
      if (response.data.status === "success") {
        setIncomeData(response.data.income);
        setPagination({
          currentPage: response.data.page,
          totalPages: response.data.totalPages,
          totalRecords: response.data.total,
          limit: response.data.limit,
          hasNextPage: response.data.page < response.data.totalPages,
          hasPrevPage: response.data.page > 1
        });
        setJumpPage(response.data.page.toString());
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled");
      } else {
        console.error("Error fetching income data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  }, [search, pagination.limit]);

  useEffect(() => {
    const controller = new AbortController();
    fetchIncomeData(pagination.currentPage, controller.signal);
    return () => controller.abort();
  }, [pagination.currentPage, fetchIncomeData]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    fetchIncomeData(1);
  };

  const handleUpdateIncome = async (index: number) => {
    const item = incomeData[index];
    setIsUpdating(true);
    try {
      const endpoint = item.isPlatinum
        ? `${API_BASE}/api/platinum/admin/updatePlatinumIncome`
        : `${API_BASE}/api/income/admin/updateSelfIncome`;

      await axios.post(endpoint, {
        email: item.email,
        income: editValue,
        date: item.createdAt,
      });

      // Update the local state
      const updatedData = [...incomeData];
      updatedData[index] = { ...item, Income: parseFloat(editValue) };
      setIncomeData(updatedData);
      setEditIndex(null);
    } catch (error) {
      console.error("Error updating income:", error);
      alert("Failed to update income");
    } finally {
      setIsUpdating(false);
    }
  };

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPagination((prev) => ({ ...prev, currentPage: newPage }));
    }
  };

  const handleLimitChange = (newLimit: number) => {
    setPagination((prev) => ({ ...prev, limit: newLimit, currentPage: 1 }));
  };

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8 pb-20">
      <div className="mb-6 md:mb-8 text-center md:text-left">
        <h1 className="text-2xl md:text-3xl font-bold text-[#523680] mb-2">Self Income</h1>
        <p className="text-sm md:text-base text-gray-600">Monitor and manage individual user earnings</p>
      </div>

      {/* Search Bar */}
      <div className="flex flex-col md:flex-row gap-3 mb-6">
        <form onSubmit={handleSearch} className="flex flex-grow gap-2">
          <div className="relative flex-grow">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search Email..."
              className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#523680]/20 shadow-sm"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="px-5 py-2.5 bg-[#523680] text-white rounded-lg hover:bg-[#523680]/90 transition-colors shadow-sm font-medium"
          >
            Search
          </button>
        </form>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => { setSearchInput(""); setSearch(""); }}
            className="flex-1 md:flex-none flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 transition-colors"
          >
            <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
            <span className="md:hidden">Refresh</span>
          </button>
        </div>
      </div>

      {/* Income Cards */}
      <div className="space-y-4">
        {isLoading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        ) : incomeData.length > 0 ? (
          incomeData.map((income, index) => (
            <div key={income._id} className="bg-white shadow-sm rounded-xl p-4 md:p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                <div className="flex-grow min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h2 className="text-base md:text-lg font-bold text-[#523680] truncate">{income.email}</h2>
                    {income.isPlatinum && (
                      <span className="shrink-0 px-2 py-0.5 rounded text-[10px] font-bold bg-amber-100 text-amber-700 uppercase">
                        Platinum
                      </span>
                    )}
                  </div>
                  <div className="flex flex-col sm:flex-row sm:gap-x-6 gap-y-1 text-xs text-gray-500">
                    <p className="flex items-center gap-1.5 font-medium italic">
                      {new Date(income.createdAt).toLocaleDateString("en-GB", {
                        day: '2-digit', month: 'short', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      })}
                    </p>
                    <p className="text-[10px] sm:text-xs">
                      <span className="font-semibold">ID:</span> {income._id}
                    </p>
                  </div>
                </div>

                <div className="flex items-center justify-between md:justify-end gap-3 pt-3 md:pt-0 border-t md:border-t-0 border-gray-50">
                  <div className="bg-green-50 px-3 py-1.5 md:px-4 md:py-2 rounded-lg text-center min-w-[100px] md:min-w-[120px]">
                    <span className="text-[10px] text-green-600 block font-bold uppercase tracking-wider">Income</span>
                    <span className="text-lg md:text-xl font-bold text-green-700">${Number(income.Income || 0).toFixed(2)}</span>
                  </div>

                  <div className="flex gap-2">
                    {editIndex === index ? (
                      <>
                        <input
                          type="number"
                          step="0.01"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          className="border border-blue-300 p-2 rounded-lg w-24 focus:ring-2 focus:ring-blue-500 outline-none"
                          autoFocus
                        />
                        <button
                          onClick={() => handleUpdateIncome(index)}
                          disabled={isUpdating}
                          className="p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 shadow-sm"
                          title="Save"
                        >
                          {isUpdating ? <RefreshCw className="h-5 w-5 animate-spin" /> : <Save className="h-5 w-5" />}
                        </button>
                        <button
                          onClick={() => setEditIndex(null)}
                          className="p-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200"
                          title="Cancel"
                        >
                          <X className="h-5 w-5" />
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => {
                          setEditIndex(index);
                          setEditValue(income.Income.toString());
                        }}
                        className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors border border-transparent hover:border-blue-100"
                        title="Edit Amount"
                      >
                        <Edit className="h-5 w-5" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="bg-gray-50 text-center py-12 rounded-xl border border-dashed border-gray-300 text-gray-500">
            No income records found.
          </div>
        )}
      </div>

      {/* Pagination */}
      {!isLoading && incomeData.length > 0 && (
        <div className="flex flex-col md:flex-row justify-between items-center mt-10 gap-6">
          <p className="text-xs text-gray-500 font-medium order-2 md:order-1">
            Showing records {((pagination.currentPage - 1) * pagination.limit) + 1} to {Math.min(pagination.currentPage * pagination.limit, pagination.totalRecords)} of {pagination.totalRecords}
          </p>
          <div className="flex items-center gap-3 order-1 md:order-2">
            <select
              value={pagination.limit}
              onChange={(e) => handleLimitChange(parseInt(e.target.value, 10))}
              className="border border-gray-200 rounded-lg px-3 py-2 text-sm font-semibold text-[#523680] bg-white"
            >
              <option value={20}>20 / page</option>
              <option value={50}>50 / page</option>
              <option value={100}>100 / page</option>
            </select>
            <div className="flex items-center gap-2 mr-2">
              <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Go to</label>
              <input
                type="text"
                value={jumpPage}
                onChange={(e) => setJumpPage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const p = parseInt(jumpPage);
                    if (p >= 1 && p <= pagination.totalPages) {
                      handlePageChange(p);
                    }
                  }
                }}
                className="w-12 p-1.5 text-center border border-gray-200 rounded-lg text-sm font-bold text-[#523680] outline-none focus:ring-2 focus:ring-[#523680]/20"
              />
            </div>

            <button
              className={`p-2 rounded-lg border transition-all ${!pagination.hasPrevPage || isLoading ? 'bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed' : 'hover:bg-gray-100 text-[#523680] border-gray-200 shadow-sm active:scale-95'}`}
              onClick={() => handlePageChange(pagination.currentPage - 1)}
              disabled={!pagination.hasPrevPage || isLoading}
            >
              <ChevronLeft className="h-5 w-5" />
            </button>

            <div className="flex gap-1.5 overflow-x-auto no-scrollbar max-w-[160px] sm:max-w-none px-1">
              {(() => {
                const pages = [];
                const maxVisible = window.innerWidth < 640 ? 3 : 5;
                let start = Math.max(1, pagination.currentPage - Math.floor(maxVisible / 2));
                let end = Math.min(pagination.totalPages, start + maxVisible - 1);

                if (end - start + 1 < maxVisible) {
                  start = Math.max(1, end - maxVisible + 1);
                }

                for (let i = start; i <= end; i++) {
                  pages.push(
                    <button
                      key={i}
                      onClick={() => handlePageChange(i)}
                      disabled={isLoading}
                      className={`h-9 w-9 md:h-10 md:w-10 rounded-lg flex items-center justify-center transition-all shrink-0 font-bold text-xs md:text-sm ${pagination.currentPage === i ? 'bg-[#523680] text-white shadow-lg' : 'border border-gray-200 hover:bg-gray-100 text-[#523680] bg-white'} ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                      {i}
                    </button>
                  );
                }
                return pages;
              })()}
            </div>

            <button
              className={`p-2 rounded-lg border transition-all ${!pagination.hasNextPage || isLoading ? 'bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed' : 'hover:bg-gray-100 text-[#523680] border-gray-200 shadow-sm active:scale-95'}`}
              onClick={() => handlePageChange(pagination.currentPage + 1)}
              disabled={!pagination.hasNextPage || isLoading}
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Income;
